import React from "react";
import { Card, Col, FloatingLabel, Form, FormControl, Row } from "react-bootstrap";
import { MdOutlineOilBarrel, MdOutlineQuestionMark, MdOutlineSolarPower } from "react-icons/md";
import { SlEnergy } from "react-icons/sl";
import { TbFlame } from "react-icons/tb";
import Validator from "../../services/Validator";
import CommonUtils from "../../utils/common";

const RegisterAnlageSmallCard = ({ anlage, errors, setErrors, data, setData, noCheckbox }) => {

    const VALIDATOR = new Validator();
    const UTILS = new CommonUtils();
    const hasSecondZaehler = anlage.x_zaehlernummer_02 !== "" && anlage.x_zaehlernummer_02 !== "False" ? true : false;
    var bg = "bg-secondary";
    var icon = <MdOutlineQuestionMark size={30} />;

    // change bg and icon according to energy form
    if (anlage.x_studio_field_3eKe0 === "Strom") { bg = 'bg-energo'; icon = <SlEnergy size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Gas") { bg = 'bg-info'; icon = <TbFlame size={30} />; }
    if (anlage.x_studio_field_3eKe0 === "Oil") { bg = 'bg-danger'; icon = <MdOutlineOilBarrel size={30} /> }
    if (anlage.x_studio_field_3eKe0 === "Strom-Einspeisung") { bg = 'bg-secondary'; icon = <MdOutlineSolarPower size={30} />; }

    return (
        <Card key={`anlCard-${anlage.id}`}>
            <Card.Header className={`${bg} text-white`}>
                <div className="border border-2 rounded-circle energo-card-header-icon">
                    {icon}
                </div>
                <div className="adjust-font-on-small energo-card-header-icon-text">
                    {anlage.x_studio_field_3eKe0}
                </div>
                <div style={{ float: "right", paddingTop: "5px" }}>
                    <span style={{ fontSize: "30px", fontWeight: "300" }}>{anlage.x_studio_field_mWMGR}</span>
                </div>
                <div className="hide-on-small" style={{ display: "inline-block", float: "right", paddingTop: "16px" }}>
                    <span>Anlagennummer ENERGO: &nbsp;</span>
                </div>
            </Card.Header>
            <Card.Body>
                <Row>
                    <Col xl={anlage.x_zaehlernummer_02 === "" || anlage.x_zaehlernummer_02 === "False" ? "12" : "6"} className={anlage.x_zaehlernummer_02 !== "" && anlage.x_zaehlernummer_02 !== "False" ? "border-right" : ""}>
                        <p>Zählernummer: &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_01}</small></p>
                        <p>Zählpunktnummer: &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_01}</small></p>
                    </Col>
                    <Col xl="6" hidden={anlage.x_zaehlernummer_02 === "" || anlage.x_zaehlernummer_02 === "False"}>
                        <p>Zählernummer: &nbsp; <small className="text-muted">{anlage.x_zaehlernummer_02}</small></p>
                        <p>Zählpunktnummer: &nbsp; <small className="text-muted">{anlage.x_zaehlpunktnummer_02}</small></p>
                    </Col>
                </Row>
                <hr />
                <Row hidden={noCheckbox}>
                    <Col>
                        <Form.Check
                            type="checkbox"
                            label="Anlage bei Energielieferant anmelden"
                            defaultChecked={anlage.register}
                            value={anlage.register}
                            onChange={e => setData(prev => ({
                                ...prev,
                                anlagen: prev.anlagen.map(obj =>
                                    obj.id === anlage.id
                                        ? { ...obj, register: e.target.checked }
                                        : obj
                                )
                            }))}

                        />
                    </Col>
                </Row>
                {anlage.register ?
                    <>
                        <Row className="mt-3">
                            <Col xl="6">
                                <FloatingLabel label="Anlage anmelden am">
                                    <FormControl
                                        type="date"
                                        placeholder="Anlage anmelden am"
                                        value={anlage.registerDate}
                                        onChange={e => {
                                            setData(prev => ({
                                                ...prev,
                                                anlagen: prev.anlagen.map(obj =>
                                                    obj.id === anlage.id
                                                        ? { ...obj, registerDate: e.target.value }
                                                        : obj
                                                )
                                            })); setErrors({}); setData(prev => ({
                                                ...prev,
                                                anlagen: prev.anlagen.map(obj =>
                                                    obj.id !== anlage.id && obj.registerDate === ""
                                                        ? { ...obj, registerDate: e.target.value }
                                                        : obj
                                                )
                                            }))
                                        }}
                                        isInvalid={errors.registerDate !== undefined && errors.registerDate[anlage.id]}
                                        isValid={VALIDATOR.dateValid(anlage.registerDate)}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xl="6">
                                <p hidden={anlage.registerDate === "" || UTILS.compareDate(new Date(anlage.registerDate), ">", new Date())}>
                                    Das Anmeldedatum liegt in der Vergangenheit. Die Anmeldung
                                    wird in Abstimmung mit dem Energielieferanten am frühest
                                    möglichen Zeitpunkt durchgeführt.
                                </p>
                            </Col>
                        </Row>
                        <Row className="mt-3">
                            <Col xl="6">
                                <FloatingLabel label="Zählerstand">
                                    <FormControl
                                        placeholder="Zählerstand"
                                        value={anlage.x_zaehlerstand_01}
                                        onChange={e => {
                                            setData(prev => ({
                                                ...prev,
                                                anlagen: prev.anlagen.map(obj =>
                                                    obj.id === anlage.id
                                                        ? { ...obj, x_zaehlerstand_01: e.target.value }
                                                        : obj
                                                )
                                            })); setErrors({})
                                        }}
                                        isInvalid={errors.x_zaehlerstand_01 !== undefined && errors.x_zaehlerstand_01[anlage.id]}
                                        isValid={VALIDATOR.IsZaehlerstand(anlage.x_zaehlerstand_01)}
                                    />
                                </FloatingLabel>
                            </Col>
                            <Col xl="6" hidden={!hasSecondZaehler}>
                                <FloatingLabel label="Zählerstand 2">
                                    <FormControl
                                        placeholder="Zählerstand 2"
                                        value={anlage.x_zaehlerstand_02}
                                        onChange={e => {
                                            setData(prev => ({
                                                ...prev,
                                                anlagen: prev.anlagen.map(obj =>
                                                    obj.id === anlage.id
                                                        ? { ...obj, x_zaehlerstand_02: e.target.value }
                                                        : obj
                                                )
                                            })); setErrors({})
                                        }}
                                        isInvalid={errors.x_zaehlerstand_02 !== undefined && errors.x_zaehlerstand_02[anlage.id]}
                                        isValid={VALIDATOR.IsZaehlerstand(anlage.x_zaehlerstand_02)}
                                    />
                                </FloatingLabel>
                            </Col>
                        </Row>
                    </>

                    :
                    <p className="text-center">Anlage noch nicht bei Energielieferant anmelden nur speichern im meine Anlagen.</p>
                }
            </Card.Body>
        </Card>
    )
}
export default RegisterAnlageSmallCard;